module.exports = __webpack_public_path__ + "media/images/logo_rexit-2c05be5eea4511be881e11a47174d33e.svg";